
import Vue from "vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import buttonCom from "@/components/ButtonCom.vue";
import box from "@/components/BoxCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
import GatewayLogCom from "./ShareComponents/GatewayLogCom.vue";
import JGLogCom from "./ShareComponents/JGLogCom.vue";
import LightLogCom from "./ShareComponents/LightLogCom.vue";
export default Vue.extend({
  components: { box, buttonCom, GatewayLogCom, JGLogCom, LightLogCom },
  data() {
    return {
      items: [] as any,
      search: null as any,
      currentPage: 1,
      pageSize: 50,
      total: 0,
      choosedItem: [] as string[],
      value1: null as any,
      value2: null as any,
    };
  },
  async mounted() {
    const value = new Date();
    let lastDay = new Date(value);
    lastDay.setDate(lastDay.getDate() - 1);
    this.value1 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate());
    this.value2 = new Date(
      value.getFullYear(),
      value.getMonth(),
      value.getDate(),
      23,
      59
    );
    await this.getLights(true);
  },
  methods: {
    more() {
      this.currentPage += 1;
      this.getLights(false);
    },
    getCondition() {
      const req = {
        page: this.currentPage,
        pageSize: this.pageSize,
        conditions: [] as any[],
        orderByConditions: [] as any[],
        noSum: true,
      };
      if (this.search) {
        req.conditions.push({
          field: "deviceTypeName",
          value: this.search,
          conditionType: 7,
        });
        req.conditions.push({
          field: "deviceName",
          value: this.search,
          conditionType: 7,
        });
        req.conditions.push({
          field: "alarmTypeName",
          value: this.search,
          conditionType: 7,
        });
      }
      console.log(Utils.FormatDataFull(this.value1));
      req.conditions.push({
        field: "createtime",
        value: this.value1,
        conditionType: 4,
        andCondition: true,
      });
      req.conditions.push({
        field: "createtime",
        value: this.value2,
        conditionType: 5,
        andCondition: true,
      });
      req.orderByConditions = [
        {
          field: "createtime",
          asc: false,
        },
      ];
      return req;
    },
    deviceSidClick(sid: string, type: number) {
      const dialog1: any = this.$refs.lightLog;
      const dialog2: any = this.$refs.gateLog;
      const dialog3: any = this.$refs.jgLog;
      switch (type) {
        case 0:
          dialog1.show(sid);
          break;
        case 1:
          dialog2.show(sid);
          break;
        case 2:
          dialog3.show(sid);
          break;
      }
    },
    async exportData() {
      const url: string = await HttpUtil.XCHttpPost(
        Urls.ExportAlarm,
        this.getCondition(),
        true,
        false
      );
      window.open(url);
    },
    async alarmAction(sid: string) {
      await HttpUtil.XCHttpPost(Urls.ResetLightState, sid, true, false);
      this.getLights(true);
    },
    async getLights(reset: boolean) {
      if (reset) {
        this.currentPage = 1;
        this.items = [];
      }
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetDeviceAlarms,
        this.getCondition(),
        true,
        false
      );
      if (this.currentPage == 1) {
        this.items = ret.data;
      } else {
        ret.data.forEach((x: any) => {
          this.items.push(x);
        });
      }
    },
    async searchClick() {
      await this.getLights(true);
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.getLights(true);
    },
    handleSelectionChange(val: any) {
      this.choosedItem = [];
      val.forEach((x: any) => {
        this.choosedItem.push(x.ctrlAddr);
      });
    },
    getData() {
      return this.choosedItem;
    },
  },
});
